import { render, staticRenderFns } from "./ExamCodePage.vue?vue&type=template&id=7c20a36f&scoped=true&"
import script from "./ExamCodePage.vue?vue&type=script&lang=js&"
export * from "./ExamCodePage.vue?vue&type=script&lang=js&"
import style0 from "./ExamCodePage.vue?vue&type=style&index=0&id=7c20a36f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c20a36f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
